import React from 'react';

import { Button } from '@mui/material';

import { en } from 'localization';

interface SwitchAccountActionProps {
  onSignOut: () => Promise<void> | void;
}

export const SwitchAccountAction: React.FC<SwitchAccountActionProps> = ({
  onSignOut,
}) => (
  <Button
    disableRipple
    onClick={() => {
      void onSignOut();
    }}
    type="button"
    variant="outlined"
  >
    {en.auth.signOutAndSwitchAccount}
  </Button>
);
